import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import CreateCheckoutOrder from "../../../components/Modal/Admin/RequisitionManagement/CreateCheckoutOrder";
import axiosInstance from "../../../hooks/axiosInstance";

export default function CheckoutApproved() {
    const [loading, setLoading] = useState(true);
    const [page, setPage] = useState(1);
    const [order, setOrders] = useState(null);
    const [pagination, setPagination] = useState({});
    const [filter, setFilter] = useState("");
    const [refreshKey, setRefreshKey] = useState(0);
    const [showCheckout, setShowCheckout] = useState(false);
    const [editCheckOut, setEditCheckOut] = useState(null);

    useEffect(() => {
        const fetchOrders = async () => {
            setLoading(true);
            try {
                const orderResponse = await axiosInstance.get("/user/check_out/get_all_order_approved_by_chain_supply", {
                    params: {
                        page,
                        filter,
                    },
                });

                setOrders(orderResponse.data.data.orders.data || []);
                setPagination(orderResponse.data.data.orders);
            } catch (error) {
                console.error("Error fetching orders:", error);
            } finally {
                setLoading(false); // Hide loader after fetching data
            }
        };

        fetchOrders();
    }, [page, filter, refreshKey]);


    const handleShowCheckout = (id) => {
        setEditCheckOut(id);
        setShowCheckout(true);

    };
    const handlePageChange = (newPage) => {
        if (newPage > 0 && newPage <= pagination.last_page) {
            setPage(newPage);
        }
    };

    const handleClose = () => {
        setShowCheckout(false);
    };
    const handleRefresh = () => {
        setRefreshKey((prevRefreshKey) => prevRefreshKey + 1);
    };

    const handleFilterChange = (event) => {
        setFilter(event.target.value);
    };

    useEffect(() => { }, [refreshKey]);

   


    return (
        <>

            <div className="row" id="contactList">
                <div className="col-lg-12">
                    <div className="card">

                        <div className="card-body border border-dashed border-end-0 border-start-0">
                            <div className="d-flex justify-content-between">
                                <div className="col-xl-4 col-md-6">
                                    <div className="search-box">
                                        <input
                                            type="text"
                                            className="form-control search"
                                            placeholder="Search product..."
                                            value={filter}
                                            onChange={handleFilterChange}
                                        />
                                        <i className="ri-search-line search-icon"></i>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="card-body">
                            <div className="table-responsive table-card">
                                <table
                                    className="table align-middle table-nowrap table table-striped table-borderless table-hover"
                                    id="customerTable"
                                >
                                    <thead className="table-light text-muted">
                                        <tr>
                                            <th scope="col">#</th>
                                            <th>Product</th>
                                            <th>Category</th>
                                            <th>Sub category</th>
                                            <th>Warehouse</th>
                                            <th>Quantity</th>
                                            <th>Order Code</th>
                                        </tr>
                                    </thead>
                                    {/* <!--end thead--> */}
                                    <tbody className="list form-check-all">
                                        {order && order.map((item, index) => (
                                            <tr key={item.id}>
                                                <td scope="row">{index + 1}</td>
                                                <td>{item.product_name}</td>
                                                <td>{item.category_name}</td>
                                                <td>{item.sub_category_name}</td>
                                                <td>{item.ware_house_name}</td>
                                                <td>{item.quantity}</td>
                                                <td>{item.order_code}</td>
                                                <td>
                                                    <div className="dropdown">
                                                        <button
                                                            className="btn btn-icon btn-sm fs-16 text-muted dropdown"
                                                            type="button"
                                                            data-bs-toggle="dropdown"
                                                            aria-expanded="false"
                                                        >
                                                            <i className="mdi mdi-apps"></i>
                                                        </button>
                                                        <ul className="dropdown-menu">
                                                            <li>
                                                                <Link
                                                                    className="dropdown-item"
                                                                    onClick={() => handleShowCheckout(item)}
                                                                >
                                                                    <i className="mdi mdi-pencil me-2 text-success"></i>{" "}
                                                                    Check-Out
                                                                </Link>
                                                            </li>
                                                        

                                                        </ul>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                                {/* <!--end table--> */}
                                <div className="d-flex mt-5 mb-5 flex-wrap">
                                    <div className="pagination-wrap hstack gap-2 mx-auto">
                                        <ul className="pagination">
                                            <li
                                                className={`page-item ${pagination.current_page === 1 ? "disabled" : ""
                                                    }`}
                                            >
                                                <button
                                                    className="page-link"
                                                    onClick={() =>
                                                        handlePageChange(pagination.current_page - 1)
                                                    }
                                                    disabled={pagination.current_page === 1}
                                                >
                                                    Previous
                                                </button>
                                            </li>
                                            {Array.from(
                                                { length: pagination.last_page },
                                                (_, index) => index + 1
                                            ).map((pageNumber) => (
                                                <li
                                                    key={pageNumber}
                                                    className={`page-item ${pageNumber === pagination.current_page
                                                        ? "active"
                                                        : ""
                                                        }`}
                                                >
                                                    <button
                                                        className="page-link"
                                                        onClick={() => handlePageChange(pageNumber)}
                                                    >
                                                        {pageNumber}
                                                    </button>
                                                </li>
                                            ))}
                                            <li
                                                className={`page-item ${pagination.current_page === pagination.last_page
                                                    ? "disabled"
                                                    : ""
                                                    }`}
                                            >
                                                <button
                                                    className="page-link"
                                                    onClick={() =>
                                                        handlePageChange(pagination.current_page + 1)
                                                    }
                                                    disabled={
                                                        pagination.current_page === pagination.last_page
                                                    }
                                                >
                                                    Next
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <CreateCheckoutOrder
                    showCheckout={showCheckout}
                    closeModal={handleClose}
                    refreshPage={handleRefresh}
                    CheckOutData={editCheckOut}

                />
            </div>
        </>
    );
}
